import { FormValidationType } from '../../../hooks/useForm';

export const validationSchema: FormValidationType = {
  name: {
    isRequired: true,
    max: 50,
  },
};
